module.exports = __webpack_public_path__ + "img/copy-text.0cd7d6b0.svg";